import React, { Component } from 'react';
import { Grid, Row, Col, ButtonToolbar, Breadcrumb, Tabs, Tab, Input, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import { SkyLightStateless } from 'react-skylight';
import axios from 'axios';

import ContentWrapper from '../Layout/ContentWrapper';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import MobileManagementTable from './MobileManagementTable';
import BillboardImagesTable from './BillboardImagesTable';
import RichTextEditor from '../Common/RichTextEditor';
import SpinnerButton from '../Common/SpinnerButton';
import {
  saveFAQBoxText,
  fetchFAQBoxText,
} from '../../actions/mobileManagement_actions';
import { companyCodeTitle, ROOT_URL } from '../../actions/root_url';

const createDialogStyle = {
  width: '800px',
  height: '800px',
  marginLeft: '-15%',
  top: '30%',
};

const createDialogStyleLimit = {
  width: "500px",
  height: "350px",
  marginLeft: "-15%",
};

class MobileManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestValue: '',
      productSearchType: 'ProductNum',
      selectedProduct: null,
      productList: [],
      tabKey: 1,
      isFAQBoxOpen: false,
      isLimitOpen: false,
      limit1: 0,
      limit2: 0,
      faqRichText: undefined,
      isLoadingFAQSave: false,
      saveFAQRichTextSuccess: false,
    };
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    // this.props.fetchGreatDealsNewArrivals();
    this.props.fetchBillboardImages();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.productList !== nextProps.productList) {
      this.setState({ productList: nextProps.productList });
    }
  }

  onSuggestionSelected = (productNum, suggestions) => {
    this.setState({ selectedProduct: suggestions }, this.addProductToTable);
  }

  addProductToTable = () => {
    this.setState((prevState) => {
      const { productList, selectedProduct } = prevState;
      const index = _.findIndex(productList, { Product_id: selectedProduct.Product_id });
      if (index === -1) {
        productList.push(selectedProduct);
      } else {
        alert('Product is already in the list');
      }
      return { productList, selectedProduct: null, suggestValue: '' };
    });
  }

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  }

  handleSelect = (tabKey) => {
    this.setState({ tabKey });
  }

  openFAQBox = () => {
    this.setState({ isFAQBoxOpen: true });
  }

  closeFAQBox = () => {
    this.setState({ isFAQBoxOpen: false });
  }

  openLimit = () => {

    let data = {};
    axios.put(
      `${ROOT_URL}v1/company/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      if (response && response.data) {
        this.setState({ isLimitOpen: true, limit1: response.data.MinQuantity, limit2: response.data.MaxQuantity });
      }
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  }

  closeLimit = () => {
    this.setState({ isLimitOpen: false });
  }

  onChangeLimit1 = (e) => {
    this.setState({ limit1: e.target.value });
  };
  onChangeLimit2 = (e) => {
    this.setState({ limit2: e.target.value });
  };
  confirmLimit = () => {
    const { limit1, limit2 } = this.state;
    let data = {
      MinQuantity: limit1,
      MaxQuantity: limit2,
    };

    axios.put(
      `${ROOT_URL}v1/company/`,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    ).then((response) => {
      alert("Catelog Quantity Limits Saved!");
      this.closeLimit();
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = 'Something went wrong on the server. Please refresh the page or try again later. If the problem persists, please contact the development team.';
      }
      alert(JSON.stringify(err.data));
    });
  };

  saveRichText = (htmlText) => {
    const handleSuccess = () => {
      this.setState({
        isLoadingFAQSave: false,
        saveFAQRichTextSuccess: true,
      });
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        isLoadingFAQSave: false,
        saveFAQRichTextSuccess: false,
      });
    };
    this.setState({
      isLoadingFAQSave: true,
      saveFAQRichTextSuccess: false,
    }, () => saveFAQBoxText(htmlText, handleSuccess, handleFailure));
  }

  fetchRichText = () => {
    const handleSuccess = (response) => {
      this.setState({
        faqRichText: response.rich_text,
        isLoadingFAQRichText: false,
      }, () => this.openFAQBox());
    };
    const handleFailure = (error) => {
      alert(error);
      this.setState({
        faqRichText: '',
        isLoadingFAQRichText: false,
      }, () => this.openFAQBox());
    };
    this.setState({
      isLoadingFAQRichText: true,
    }, () => fetchFAQBoxText(handleSuccess, handleFailure));
  }

  renderAutoSuggest() {
    return (
      <div className="control-dropdown">
        <GenericProductSuggest
          value={this.state.suggestValue}
          onChange={(e, { newValue }) => { this.setState({ suggestValue: newValue }); }}
          SearchType={this.state.productSearchType}
          fetchOrdersByProduct={this.onSuggestionSelected}
        />
      </div>
    );
  }

  renderBillboardImagesTable() {
    const {
      billboardImagesList,
      billboardImagesIsLoading,
      saveBillboardImages,
      savingBillboardImages,
      fetchBillboardImages,
      deleteBillboardImage,
      deletingBillboardImage,
    } = this.props;
    return (
      <BillboardImagesTable
        rows={billboardImagesList}
        rowsIsLoading={billboardImagesIsLoading}
        saveBillboardImages={saveBillboardImages}
        saving={savingBillboardImages}
        reload={fetchBillboardImages}
        delete={deleteBillboardImage}
        deleting={deletingBillboardImage}
      />
    );
  }

  renderGreatDealsTable() {
    const { productList } = this.state;
    const {
      productListIsLoading,
      updateGreatDeals,
      updateNewArrivals,
      isUpdating,
    } = this.props;
    return (
      <MobileManagementTable
        // title={<Translate value="great_deals/new_arrivals" />}
        rows={productList}
        rowsIsLoading={productListIsLoading}
        saveProducts={{
          saveGreatDeals: updateGreatDeals,
          saveNewArrivals: updateNewArrivals,
        }}
        isUpdating={isUpdating}
      />
    );
  }

  render() {
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            <Translate value="mobile_management" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar id="breadcrumbButtonGroup">
        {/* <SpinnerButton
            bsStyle="success"
            onClick={this.openLimit}
            disabled={false}
            loading={false}
            icon="fa-pencil"
            translation={<Translate value="catelog_qty_limit" />}
    /> */}
          <SpinnerButton
            bsStyle="primary"
            onClick={this.fetchRichText}
            disabled={this.state.isLoadingFAQRichText}
            loading={this.state.isLoadingFAQRichText}
            icon="fa-pencil"
            translation={<Translate value="faq" />}
          />
        </ButtonToolbar>
        <Grid id="mobile-management">
          <Col xs={10} xsOffset={1}>
            <Tabs activeKey={this.state.tabKey} justified onSelect={this.handleSelect}>
              {/* <Tab eventKey={1} title={<Translate value="great_deals/new_arrivals" />}>
                <Col>
                  <Panel id="search-panel">
                    <Col xs={12} className="search-panel-left">
                      <div id="autosuggest-div">
                        <Row style={{ height: '30px' }}>
                          <Col xs={12}>
                            <TypeRadios
                              value={this.state.productSearchType}
                              handleOptionChange={this.handleOptionChange}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            { this.renderAutoSuggest() }
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Panel>
                </Col>
                <Col>
                  { this.renderGreatDealsTable() }
                </Col>
              </Tab> */}
              <Tab eventKey={1} title={<Translate value="billboard_images" />}>
                <Col>
                  { this.renderBillboardImagesTable() }
                </Col>
              </Tab>
            </Tabs>
          </Col>
          <SkyLightStateless
            dialogStyles={createDialogStyle}
            isVisible={this.state.isFAQBoxOpen}
            onCloseClicked={this.closeFAQBox}
            title={<Translate value="faq" />}
          >
            <RichTextEditor
              htmlString={this.state.faqRichText}
              placeholder="Enter the frequently asked questions."
              saveHtml={(richText) => { this.saveRichText(richText); }}
              isLoadingSave={this.state.isLoadingFAQSave}
              saveSuccess={this.state.saveFAQRichTextSuccess}
            />
          </SkyLightStateless>
          <SkyLightStateless
            dialogStyles={createDialogStyleLimit}
            isVisible={this.state.isLimitOpen}
            onCloseClicked={this.closeLimit}
            title={<Translate value="catelog_qty_limit" />}
          >
          <Row className="centerStyle">
          <Col sm={12}>
             <label>x &gt; max : Available</label>
            <br></br>
            <label>x  &lt; min : Out-of-stock</label>
            <br></br>
            <label style={{marginBottom: '10px'}}>min &lt; x &lt; min : show the real quantity
            </label>
            <br></br>
            </Col>
          </Row>
          <Row className="centerStyle">
            <Col sm={12}>
              <label><Translate value="min_qty" /></label>
            </Col>
          </Row>
          <Row className="centerStyle">
          <Col sm={4}></Col>
            <Col sm={4}>
              <Input type="text" value={this.state.limit1} onChange={this.onChangeLimit1} />
            </Col>
            <Col sm={4}></Col>
          </Row>
          <Row className="centerStyle">
            <Col sm={12}>
              <label><Translate value="max_qty" /></label>
            </Col>
          </Row>
          <Row className="centerStyle">
          <Col sm={4}></Col>
            <Col sm={4}>
              <Input type="text" value={this.state.limit2} onChange={this.onChangeLimit2} />
            </Col>
            <Col sm={4}></Col>
          </Row>
          <br />
          <ButtonToolbar className="button-toolbar-center">
            <Button
              bsStyle="success"
              onClick={this.confirmLimit}
              type="button"
            >
              <Translate value="confirm" />
            </Button>
          </ButtonToolbar>

          </SkyLightStateless>
        </Grid>
      </ContentWrapper>
    );
  }
}

MobileManagement.defaultProps = {
  isUpdating: false,
  isUpdated: false,
  productList: [],
  productListIsLoading: false,
  billboardImagesList: [],
  billboardImagesIsLoading: false,
  savingBillboardImages: false,
  deletingBillboardImage: false,
};

MobileManagement.propTypes = {
  fetchGreatDealsNewArrivals: PropTypes.func.isRequired,
  fetchBillboardImages: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool,
  isUpdated: PropTypes.bool,
  productList: PropTypes.array,
  productListIsLoading: PropTypes.bool,
  updateGreatDeals: PropTypes.func.isRequired,
  updateNewArrivals: PropTypes.func.isRequired,
  billboardImagesList: PropTypes.array,
  billboardImagesIsLoading: PropTypes.bool,
  saveBillboardImages: PropTypes.func.isRequired,
  savingBillboardImages: PropTypes.bool,
  deleteBillboardImage: PropTypes.func.isRequired,
  deletingBillboardImage: PropTypes.bool,
};

export default MobileManagement;



// WEBPACK FOOTER //
// ./master/jsx/components/General/MobileManagement.jsx